import { useTranslation } from "react-i18next";
import { Label, Input, StringSelect } from "@tellescope/ui";
import type { ButtonBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import { StyleSection } from "../shared/StyleSection";
import type { BlockTypeEditorProps } from "../types";

type ButtonBlockEditorProps = BlockTypeEditorProps<ButtonBlock>;

export function ButtonBlockEditor({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  updateStyle,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
  styleOpen,
  setStyleOpen,
}: ButtonBlockEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label>{t("Button Text")}</Label>
        <Input
          value={block.props.text}
          onChange={(e) => updateProps({ text: e.target.value })}
          placeholder={t("Click me")}
        />
      </div>
      <div className="space-y-2">
        <Label>{t("Link URL (optional)")}</Label>
        <Input
          value={block.props.href || ""}
          onChange={(e) => updateProps({ href: e.target.value || undefined })}
          placeholder="https://..."
        />
      </div>
      <StringSelect
        label={t("Style")}
        value={block.props.variant}
        onValueChange={(value) => updateProps({ variant: value })}
        options={[
          { value: "default", label: t("Default") },
          { value: "secondary", label: t("Secondary") },
          { value: "outline", label: t("Outline") },
          { value: "ghost", label: t("Ghost") },
        ]}
      />
      <StyleSection style={block.style} onChange={updateStyle} open={styleOpen} onOpenChange={setStyleOpen} />
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
}
